import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0da22945"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ant-row" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-12" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24" }
const _hoisted_15 = { class: "ant-row" }
const _hoisted_16 = { class: "ant-col ant-col-xs-8" }
const _hoisted_17 = { class: "ant-col ant-col-xs-8" }
const _hoisted_18 = { class: "ant-col ant-col-xs-8" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24" }
const _hoisted_21 = {
  key: 0,
  class: "tabela-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_analise_curva_abc = _resolveComponent("selecionar-analise-curva-abc")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_titulo_padrao, {
              identificadorRecurso: 'VENDAS',
              tituloRecurso: _ctx.state.tituloRecurso,
              exibirAtalhosTela: false,
              exibirHistoricoTela: true,
              empresasSelecionadas: [_ctx.dadosEmpresa.codigoEmpresa]
            }, {
              BotoesAcoes: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Imprimir",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                    }, [
                      _createVNode(_component_icone, { nome: "imprimir" })
                    ]),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Exportar Word",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                    }, [
                      _createVNode(_component_icone, { nome: "word" })
                    ]),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Exportar Excel",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                    }, [
                      _createVNode(_component_icone, { nome: "excel" })
                    ]),
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary ss-btn-recursos",
                      title: "Exportar CSV",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                    }, [
                      _createVNode(_component_icone, { nome: "download-arquivo" })
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "ant-btn ant-btn-primary ss-btn-tela",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.buscarRelatorio && _ctx.buscarRelatorio(...args)))
                    }, _hoisted_7)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["tituloRecurso", "empresasSelecionadas"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_collapse, {
              ghost: "",
              activeKey: _ctx.state.mostraFiltros,
              "onUpdate:activeKey": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.mostraFiltros) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_collapse_panel, {
                  key: "1",
                  header: "Filtros"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_card, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form, { layout: "vertical" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_a_form_item, {
                                  label: "Data Inicial e Final",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_data_inicial_final, {
                                      dataInicialSelecionada: _ctx.state.dataInicial,
                                      "onUpdate:dataInicialSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.dataInicial) = $event)),
                                      dataFinalSelecionada: _ctx.state.dataFinal,
                                      "onUpdate:dataFinalSelecionada": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.dataFinal) = $event)),
                                      onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.buscarRelatorio()))
                                    }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_a_form_item, {
                                  label: "Tipo Análise",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_analise_curva_abc, {
                                      valor: _ctx.state.tipoAnalise,
                                      "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.tipoAnalise) = $event)),
                                      disabled: false,
                                      "radio-button": false
                                    }, null, 8, ["valor"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_card, { title: "Percentual das Classes" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_15, [
                                      _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_a_form_item, { label: "Classe A %" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.state.classeA,
                                              "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.classeA) = $event))
                                            }, null, 8, ["valor"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_component_a_form_item, { label: "Classe B %" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.state.classeB,
                                              "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.classeB) = $event))
                                            }, null, 8, ["valor"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_18, [
                                        _createVNode(_component_a_form_item, { label: "Classe C %" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_campo_numerico, {
                                              valor: _ctx.state.classeC,
                                              "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.classeC) = $event))
                                            }, null, 8, ["valor"])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_a_form_item, {
                                  label: "Produto",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_produto, {
                                      varios: true,
                                      codigosSelecionados: _ctx.state.produtos,
                                      "onUpdate:codigosSelecionados": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.produtos) = $event)),
                                      empresas: [_ctx.dadosEmpresa.codigoEmpresa]
                                    }, null, 8, ["codigosSelecionados", "empresas"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.temDados)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_tabs, { type: "card" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, {
                    key: "1",
                    tab: "Classe A"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas,
                        "data-source": _ctx.state.dadosRelatorio.itensClasseA,
                        pagination: { pageSize: 50 },
                        scroll: { y: 400 },
                        size: "small",
                        rowKey: "codigo"
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'faturamento')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.faturamento, 2, true, true)), 1)
                              ], 64))
                            : (column.key === 'lucratividade')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.lucratividade, 2, true, true)), 1)
                                ], 64))
                              : (column.key === 'quantidade')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, 4)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "2",
                    tab: "Classe B"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas,
                        "data-source": _ctx.state.dadosRelatorio.itensClasseB,
                        pagination: { pageSize: 50 },
                        scroll: { y: 400 },
                        size: "small",
                        rowKey: "codigo"
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'faturamento')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.faturamento, 2, true, true)), 1)
                              ], 64))
                            : (column.key === 'lucratividade')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.lucratividade, 2, true, true)), 1)
                                ], 64))
                              : (column.key === 'quantidade')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, 4)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, {
                    key: "3",
                    tab: "Classe C"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.gradeBase.colunas,
                        "data-source": _ctx.state.dadosRelatorio.itensClasseC,
                        pagination: { pageSize: 50 },
                        scroll: { y: 400 },
                        size: "small",
                        rowKey: "codigo"
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'faturamento')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.faturamento, 2, true, true )), 1)
                              ], 64))
                            : (column.key === 'lucratividade')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.lucratividade, 2, true, true)), 1)
                                ], 64))
                              : (column.key === 'quantidade')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.quantidade, 4)), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivoPdf
    }, null, 8, ["arquivos"])
  ]))
}